import React, { useState } from "react";
import GeneralReservation from "./reservations/General";
import CommuteReservation from "./reservations/Commute";
import TourReservation from "./reservations/Tour";
import SchoolReservation from "./reservations/School";
import AllReservation from "./reservations/All";
import Header from "../Component/Header";

export default function ReservationManager() {
  const [type, setType] = useState("all"); // all | general | commute | tour | school
  const [reservationMode, setReservationMode] = useState("예약");


  const renderComponent = () => {
    switch (type) {
      case "commute":
        return <CommuteReservation reservationMode={reservationMode} />;
      case "tour":
        return <TourReservation reservationMode={reservationMode} />;
      case "school":
        return <SchoolReservation reservationMode={reservationMode} />;
      case "all":
        return <AllReservation reservationMode={reservationMode} />;
      default:
        return <GeneralReservation reservationMode={reservationMode} />;
    }
  };

  return (
    <div>
      <Header />
      <div className="flex flex-wrap px-4 py-1.5 items-center gap-2 md:gap-4 no-print">
        <label className="font-semibold">구분</label>
          <div className="flex flex-wrap gap-1 md:gap-2">
          {["전체","일반", "학단", "통근", "투어"].map((label) => {
            const value = {
              "전체": "all",
              "일반": "general",
              "학단": "school",
              "통근": "commute",
              "투어": "tour"
            }[label];

            return (
              <button
                key={value}
                type="button"
                onClick={() => setType(value)}
                className={`px-2 md:px-4 py-1 rounded-full border transition ${
                  type === value
                    ? "bg-blue-600 text-white"
                    : "bg-gray-100 text-gray-700 hover:bg-gray-200"
                }`}
              >
                {label}
              </button>
            );
          })}
          </div>
          <div className="md:ml-4 flex gap-2">
          {["예약", "가예약"].map((label) => (
            <button
              key={label}
              type="button"
              onClick={() => setReservationMode(label)}
              className={`px-4 py-1 rounded-full border transition ${
                reservationMode === label
                  ? "bg-emerald-600 text-white"
                  : "bg-gray-100 text-gray-700 hover:bg-gray-200"
              }`}
            >
              {label}
            </button>
          ))}
          </div>
        </div>
      {/* ✅ 선택된 컴포넌트 렌더링 */}
      <div className="-mt-1">{renderComponent()}</div>
    </div>
  );
}
